<div class="form-group" ngModelGroup="formField{{ formField.id }}">
    @if (formField.label) {
        <label for="form-element-{{ formField.id }}" (click)="selectElement?.focus()" class="form-element-label">
            {{ formField.label }}{{ formField.isRequired ? ' *' : '' }}
        </label>
    }
    @if (!isMobileOrTabletDevice()) {
        <ng-select
            id="form-element-{{ formField.id }}"
            name="formField{{ formField.id }}"
            appSelectAccessibility
            [inputAriaLabelAttribute]="labelText || formField.placeholder"
            bindLabel="value"
            bindValue="value"
            dropdownPosition="bottom"
            class="select-control"
            #select
            appFocus
            [appAutoFocus]="formField.isNeedToFocus"
            [focusableSelectElement]="selectElement"
            (change)="onSelect()"
            [ngClass]="{ 'ng-invalid': formField.isRequired && !formField.value }"
            [placeholder]="formField.placeholder"
            [items]="formField.possibleValues"
            [required]="formField.isRequired"
            [(ngModel)]="selectedValue">
        </ng-select>
    } @else {
        <select
            id="form-element-{{ formField.id }}"
            class="form-control"
            name="formField{{ formField.id }}"
            [title]="labelText ? '' : formField.placeholder"
            (change)="onSelect()"
            [ngClass]="{ 'ng-invalid': formField.isRequired && !formField.value, 'select-placeholder': !selectedValue }"
            [(ngModel)]="selectedValue"
            [required]="formField.isRequired">
            <option [ngValue]="null">
                <span>{{ formField.placeholder }}</span>
            </option>
            @for (option of formField.possibleValues; track option) {
                <option value="{{ option.value }}">
                    {{ option.value }}
                </option>
            }
        </select>
    }

    @if (formService.isSubmitted && !formField.value && formField.isRequired) {
        <div class="text-danger" translate>Please fill this field</div>
    }
</div>
